export default function ContentPolicy() {
  return (
    <>
      <h2>Content Policy</h2>
      <p> Last Updated: 5/14/22</p>

      Be kind, no porn, don't waste space in our database. 
    </>
  
  )}
